import { useMutation } from "@tanstack/react-query";
import { OperationType } from "@/prisma/generated/enums";

const ENDPOINT = "/api/hrin/immat/flows";

export type ToggleImmatriculationFlowBody = {
  flowType: OperationType;
  isActive: boolean;
};

export type ToggleImmatriculationFlowResponse = {
  success: boolean;
  data: {
    flowType: OperationType;
    isActive: boolean;
    versionNumber: number;
  };
};

export function useToggleImmatriculationFlowMutation() {
  return useMutation({
    mutationFn: async (body: ToggleImmatriculationFlowBody) => {
      const res = await fetch(ENDPOINT, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
      });

      if (!res.ok) {
        const text = await res.text();
        throw new Error(text || "Error");
      }

      return res.json() as Promise<ToggleImmatriculationFlowResponse>;
    },
  });
}
